import { Grid, Typography, Box } from '@mui/material'
import { get } from 'lodash'
import { useTranslation } from 'react-i18next'

export default function CustomerViewDetails({ tempOrder }) {
    const { t } = useTranslation()

    const user = tempOrder?.user
    const address = user?.address
    const coordinates = user?.location?.coordinates

    return (
        <Box>
            <Grid container spacing={2}>
                {/* Contact Information */}
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom>
                        {t("User's Info")}
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("Name")}
                        </Typography>
                        <Typography variant="body1">
                            {get(user, "name") || "-"}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("Phone")}
                        </Typography>
                        <Typography variant="body1">
                            <bdi>
                                {get(user, "phone") || "-"}
                            </bdi>
                        </Typography>
                    </Box>
                </Grid>

                {/* Address Information */}
                <Grid item xs={12}>
                    <Typography variant="h5" gutterBottom sx={{ mt: 2 }}>
                        {t("Address Info")}
                    </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("State/Region")}
                        </Typography>
                        <Typography variant="body1">
                            {get(address, "state") || "-"}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("City")}
                        </Typography>
                        <Typography variant="body1">
                            {get(address, "city") || "-"}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("District")}
                        </Typography>
                        <Typography variant="body1">
                            {get(address, "area") || "-"}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("Street")}
                        </Typography>
                        <Typography variant="body1">
                            {get(address, "street") || "-"}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("Building No.")}
                        </Typography>
                        <Typography variant="body1">
                            {get(address, "houseNumber") || "-"}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Box>
                        <Typography variant="body2" fontWeight="bold" color="text.secondary">
                            {t("Details")}
                        </Typography>
                        <Typography variant="body1">
                            {get(address, "landmark") || "-"}
                        </Typography>
                    </Box>
                </Grid>

                {/* Location Coordinates */}
                {coordinates && coordinates.length === 2 && (
                    <Grid item xs={12}>
                        <Box>
                            <Typography variant="body2" fontWeight="bold" color="text.secondary">
                                {t("Location Coordinates")}
                            </Typography>
                            <Typography variant="body1">
                                {`${coordinates[0]}, ${coordinates[1]}`}
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}